import { render, staticRenderFns } from "./DataComponent.vue?vue&type=template&id=328b89f9&scoped=true&lang=pug&"
import script from "./DataComponent.vue?vue&type=script&lang=js&"
export * from "./DataComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataComponent.vue?vue&type=style&index=0&id=328b89f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b89f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VDatePicker,VMenu,VSpacer,VTextField,VTimePicker})
